import { render } from "./StoreRequisitionList.vue?vue&type=template&id=3d8405b5&scoped=true"
import script from "./StoreRequisitionList.vue?vue&type=script&lang=js"
export * from "./StoreRequisitionList.vue?vue&type=script&lang=js"

import "./StoreRequisitionList.vue?vue&type=style&index=0&id=3d8405b5&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8405b5"]])

export default __exports__